
import React from 'react';
import './OurStory.css';

interface TimelineEvent {
  coordinates: string;
  description?: string;
  image?: string;
  images?: string[];
}

const OurStory: React.FC = () => {
  // Gallery images from the gallery folder (shuffled)
  const galleryImages: string[] = [
    'images/gallery/gallery_20.png',
    'images/gallery/gallery_3.png',
    'images/gallery/gallery_14.png',
    'images/gallery/gallery_7.png',
    'images/gallery/gallery_18.png',
    'images/gallery/gallery_1.png',
    'images/gallery/gallery_25.png',
    'images/gallery/gallery_11.png',
    'images/gallery/gallery_5.png',
    'images/gallery/gallery_19.png',
    'images/gallery/gallery_9.png',
    'images/gallery/gallery_23.png',
    'images/gallery/gallery_2.png',
    'images/gallery/gallery_16.png',
    'images/gallery/gallery_12.png',
    'images/gallery/gallery_8.png',
    'images/gallery/gallery_21.png',
    'images/gallery/gallery_4.png',
    'images/gallery/gallery_15.png',
    'images/gallery/gallery_10.png',
    'images/gallery/gallery_24.png',
    'images/gallery/gallery_6.png',
    'images/gallery/gallery_17.png',
    'images/gallery/gallery_13.png',
    'images/gallery/gallery_22.png',
    'images/gallery/abay.png',
    'images/gallery/camping.png',
    'images/gallery/italy.png',
    'images/gallery/oren.png',
    'images/gallery/sandiago.png',
    'images/gallery/wedding.png',
    'images/gallery/wedding_2.png',
    'images/gallery/wedding_3.png',
  ];

  const events: TimelineEvent[] = [
    {
      coordinates: '21.2776° N, 157.6960° W',
      description: 'Lance & Morgan met in the most unconventional of ways. Morgan was visiting Alison Austin (now Caffrey) in Honolulu, Hawaii and a friend group had gathered to hike Kokohead. Lance & Morgan briefly chatted at the top of the lookout but really hit it off later that week at Encore and Aloha Beer Co (special credit to Rachel Wedge who was the first to spot the budding romance). Though, the jury is still out on who made the first move.',
      image: 'images/hawai_2.jpg',
    },
    {
      coordinates: '41.9172° N, 87.6270° W',
      description: 'From Facetime dates to weekend adventures all over the world, Lance and Morgan started a long distance relationship from Honolulu to Chicago.',
      image: 'images/long_1.jpg', // Placeholder for image
    },
    {
      coordinates: '41.8832° N, 87.6324° W',
      description: 'Lance and Cashew moved to Chicago. Finally together/in the same time zone, Morgan & Lance love exploring new restaurants, perfecting their latte recipes, spending time on the lake, planning their next trip, and hanging out with their favorite people. Cashew is a regular at the city dog parks and remains a frisbee fanatic.',
      image: 'images/chi_3.jpg', // Placeholder for image
    },
    {
      coordinates: '31.6225° N, 7.9898° W',
      description: 'One of Lance\'s favorite memories is adventure traveling around Morocco. From riding the night train from Tangier to Marrakech to getting lost in the souks, Morocco is home to some of their favorite experiences together.',
      images: ['images/lance_train.png', 'images/morgan_door.png'],
    },
    {
      coordinates: '39.6341° N, 105.8715° W',
      description: 'One of Morgan\'s favorite memories is Lance pushing her out of her comfort zone and getting her back into skiing. Morgan now dreams of having a family of little rippers (skiers) so she\'ll keep practicing and fully intends to zoom past Lance down the East Wall of A Basin someday (stay tuned).',
      image: 'images/skiing.png',
    },
    {
      coordinates: '19.6861° N, 98.8716° W',
      description: 'In a hot air balloon overlooking Mexico City sunrise, Lance pulled off the most magical proposal and Morgan said yes.',
      image: 'images/mexico_3.jpg',
    },
    {
      coordinates: '39.7541° N, 3.1327° E',
      description: 'Lance & Morgan cannot wait to celebrate with you in Mallorca! Nobody is surprised these two decided to plan a destination wedding and they cannot wait to travel and celebrate with all their favorite people.',
      image: 'images/ireland_1.jpg',
    },
  ];

  return (
    <div className="our-story">
      <div className="timeline">
        {events.map((event, index) => (
          <div key={index} className={`timeline-item ${index % 2 === 0 ? 'left' : 'right'}`}>
            <div className="timeline-dot"></div>
            <div className="timeline-content">
              <div className="coordinates">{event.coordinates}</div>
              {event.description && <p>{event.description}</p>}
            </div>
            <div className="timeline-image">
              {event.image && <img src={event.image} alt={event.coordinates} />}
              {event.images && (
                <div className="timeline-image-collage">
                  {event.images.map((img: string, imgIndex: number) => (
                    <img key={imgIndex} src={img} alt={`${event.coordinates} - ${imgIndex + 1}`} />
                  ))}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>

      <div className="photo-gallery">
        <h2 className="gallery-title">Photo Gallery</h2>
        <div className="gallery-grid">
          {galleryImages.map((image, index) => (
            <div key={index} className="gallery-item">
              <img src={image} alt={`Gallery ${index + 1}`} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default OurStory;
